import { render, staticRenderFns } from "./FiscalEsirs.vue?vue&type=template&id=b9bcaf10&scoped=true"
import script from "./FiscalEsirs.vue?vue&type=script&lang=js"
export * from "./FiscalEsirs.vue?vue&type=script&lang=js"
import style0 from "./FiscalEsirs.vue?vue&type=style&index=0&id=b9bcaf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bcaf10",
  null
  
)

export default component.exports